<template>
  <div
    class="d-flex outer-column row m-0 p-0"
    :class="`col-md-${outerColumnFlexGrow}`"
  >
    <div
      class="inner-column overflow-auto p-0 m-0"
      :class="`col-md-${innerColumnFlexGrow}`"
    >
      <Square
        v-for="(node, index) in data"
        :key="node[nodeText]"

        :centered="true"
        :class="selectedNodeIndex === index ?
          'deepify-bg-success text-light ' + getSquareClass(index, data.length) :
          'bg-light ' + getSquareClass(index, data.length) "
        class="mr-2 mb-2"

        @click.native="selectNode(index)"
      >
        <div class="text-center px-3">
          <h6 class="text-uppercase p-0 m-0">
            {{ node[nodeText] }}
          </h6>
        </div>
      </Square>
    </div>
    <SelectionTreeList
      v-if="isNextNodeAvailable"
      :key="level + 1"
      v-model="value"
      :data="selectedNode.children"
      :level="level + 1"
      :node-text="nodeText"
    />
  </div>
</template>
<script>
import Square from '@/components/core/Square.vue';
import EventBus from '@/services/eventBus';

export default {
  name: 'SelectionTreeList',
  components: {
    Square,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      default: 1,
    },
    nodeText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedNodeIndex: -1,
      totalNodeCount: 1,
    };
  },
  computed: {
    selectedNode() {
      return this.selectedNodeIndex > -1 ? this.data[this.selectedNodeIndex] : null;
    },
    isNextNodeAvailable() {
      return this.selectedNode && this.selectedNode.children && this.selectedNode.children.length;
    },
    totalChildNodeCount() {
      return this.totalNodeCount - this.level;
    },
    outerColumnFlexGrow() {
      switch (this.level) {
        case 1: return 12;
        case 2: return 8;
        case 3: return 6;
        default: return 12;
      }
    },
    innerColumnFlexGrow() {
      switch (this.level) {
        case 1: return 4;
        case 2: return 6;
        case 3: return 12;
        default: return 4;
      }
    },
  },
  watch: {
    selectedNodeIndex() {
      this.updateTotalNodeCount();
    },
  },
  created() {
    const selectedNode = this.value[0];

    if (selectedNode) {
      const nodeId = selectedNode.path.split(',')[this.level];
      if (nodeId) {
        this.selectNode(this.data.findIndex((d) => d._id === nodeId));
      } else {
        this.selectNode(this.data.findIndex((d) => d._id === selectedNode._id));
      }
    }

    this.initEvents();
  },
  methods: {
    initEvents() {
      EventBus.$on('node-count-changed', (payload) => {
        this.totalNodeCount = payload;
      });

      EventBus.$on('resetted', (payload) => {
        if (this.level > payload) {
          this.selectedNodeIndex = -1;
        }
      });
    },
    updateTotalNodeCount() {
      if (this.isNextNodeAvailable) {
        EventBus.$emit('node-count-changed', this.level + 1);
      } else {
        EventBus.$emit('node-count-changed', this.level);
      }
    },
    selectNode(index) {
      // save selected index
      this.selectedNodeIndex = index;

      EventBus.$emit('resetted', this.level);

      if (!this.isNextNodeAvailable) {
        EventBus.$emit('selected', [this.selectedNode]);
        EventBus.$emit('completed', true);
      } else {
        EventBus.$emit('selected', []);
        EventBus.$emit('completed', false);
      }
    },
    getSquareClass(index) {
      if (index === 0) return 'rounded-bottom-2';
      return 'rounded-2';
    },
  },
};
</script>
<style>
.card {
  min-height: 90px;
}
</style>
